/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snap_To_Shot_Changes_DescInputs */

const en_snap_to_shot_changes_desc = /** @type {(inputs: Snap_To_Shot_Changes_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snap event start and end times to shot changes`)
};

const fr_snap_to_shot_changes_desc = /** @type {(inputs: Snap_To_Shot_Changes_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aligner les temps de début et de fin sur les changements de plan`)
};

const de_snap_to_shot_changes_desc = /** @type {(inputs: Snap_To_Shot_Changes_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start- und Endzeiten von Schnappschüssen für Aufnahmeänderungen`)
};

const it_snap_to_shot_changes_desc = /** @type {(inputs: Snap_To_Shot_Changes_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggancia gli orari di inizio e fine dell'evento alle modifiche dello scatto`)
};

const ru_snap_to_shot_changes_desc = /** @type {(inputs: Snap_To_Shot_Changes_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Снимок времени начала и окончания события для смены ракурса.`)
};

const es_snap_to_shot_changes_desc = /** @type {(inputs: Snap_To_Shot_Changes_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar las horas de inicio y finalización de los eventos a los cambios de toma`)
};

const zh_cn2_snap_to_shot_changes_desc = /** @type {(inputs: Snap_To_Shot_Changes_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快照事件的开始和结束时间与镜头变化相关`)
};

const ja_snap_to_shot_changes_desc = /** @type {(inputs: Snap_To_Shot_Changes_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントの開始時間と終了時間をショットの変更にスナップします`)
};

const hi_snap_to_shot_changes_desc = /** @type {(inputs: Snap_To_Shot_Changes_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्नैप इवेंट के शुरू और खत्म होने के समय को शॉट में बदलाव के साथ जोड़ें`)
};

const pt_pt2_snap_to_shot_changes_desc = /** @type {(inputs: Snap_To_Shot_Changes_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajuste os horários de início e término do evento às alterações de disparo.`)
};

/**
* | output |
* | --- |
* | "Snap event start and end times to shot changes" |
*
* @param {Snap_To_Shot_Changes_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_shot_changes_desc = /** @type {((inputs?: Snap_To_Shot_Changes_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Shot_Changes_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snap_to_shot_changes_desc(inputs)
	if (locale === "de") return de_snap_to_shot_changes_desc(inputs)
	if (locale === "it") return it_snap_to_shot_changes_desc(inputs)
	if (locale === "ru") return ru_snap_to_shot_changes_desc(inputs)
	if (locale === "es") return es_snap_to_shot_changes_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_snap_to_shot_changes_desc(inputs)
	if (locale === "ja") return ja_snap_to_shot_changes_desc(inputs)
	if (locale === "hi") return hi_snap_to_shot_changes_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_snap_to_shot_changes_desc(inputs)
	return en_snap_to_shot_changes_desc(inputs)
});